/* PIRRA PDP: gallery (dots/thumbs), colour + size -> variant id, pack picker (real units), brand cart drawer after add, review slider */
(function () {
  var tr = document.querySelector('[data-prr-track]'), dots = document.querySelector('[data-prr-dots]'), thumbs = document.querySelector('[data-prr-thumbs]');
  function imgs() { return tr ? Array.prototype.slice.call(tr.children) : []; }
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (dots) dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (dots) { dots.innerHTML = Array(imgs().length + 1).join('<span></span>'); dots.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); }); }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  /* variants */
  var V = []; try { V = JSON.parse(document.querySelector('[data-prr-variants]').textContent); } catch (e) {}
  var vid = document.querySelector('[data-prr-vid]'), lab = document.querySelector('[data-prr-colour]'), atc = document.querySelector('.prr-atc');
  function val(n) { var c = document.querySelector('input[name="' + n + '"]:checked'); return c ? c.value : null; }
  function sync(scroll) {
    var col = val('prr-colour'), size = val('prr-size');
    var v = V.filter(function (x) { return x.option1 === col && x.option2 === size; })[0];
    if (lab) lab.textContent = col;
    if (v && vid) {
      vid.value = v.id;
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    if (scroll && tr) { var all = imgs(); for (var k = 0; k < all.length; k++) if ((all[k].alt || '').toLowerCase().indexOf(col.toLowerCase() + ' ') === 0) { go(k); break; } }
  }
  document.querySelectorAll('input[name="prr-colour"]').forEach(function (i) { i.addEventListener('change', function () { sync(true); }); });
  document.querySelectorAll('input[name="prr-size"]').forEach(function (i) { i.addEventListener('change', function () { sync(false); }); });
  if (V.length) sync(false);
  /* pack picker */
  var q = document.querySelector('[data-prr-qty]'), now = document.querySelector('[data-prr-now]');
  document.querySelectorAll('.prr-pk input').forEach(function (r) {
    r.addEventListener('change', function () {
      document.querySelectorAll('.prr-pk').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
      if (q) q.value = r.value;
      if (now) now.textContent = r.dataset.now;
    });
  });
  /* brand cart drawer after any add */
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; if (window.PRR) window.PRR.openCart(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  var form = document.querySelector('form[data-prr-add]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      var fd = new FormData(form); fd.delete('prr-colour'); fd.delete('prr-size'); fd.delete('prr-pack');
      fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }
  /* review slider + shop now */
  document.querySelectorAll('[data-prr-rs]').forEach(function (c) {
    var t = c.querySelector('.prr-rs__track');
    c.querySelectorAll('.prr-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth, behavior: 'smooth' }); }); });
  });
  document.querySelectorAll('[data-prr-top-old]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }); });
})();

/* PIRRA additions: "Choose your pack" -> buy box, show more reviews, sticky bar once the buy box is out of view */
(function () {
  function buy() { return document.querySelector('.prr-ticks') || document.getElementById('prr-buy'); }
  document.querySelectorAll('[data-prr-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var b = buy();
      if (b) window.scrollTo({ top: b.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    });
  });
  var more = document.querySelector('[data-prr-more]'), list = document.querySelector('[data-prr-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var st = document.querySelector('[data-prr-sticky]'), form = document.getElementById('prr-buy');
  if (st && form && 'IntersectionObserver' in window) {
    var seen = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen = true; st.classList.toggle('is-on', seen && !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
})();


/* PIRRA additions: image counter, size guide link -> opens the Size & fit accordion */
(function () {
  var tr = document.querySelector('[data-prr-track]'), cnt = document.querySelector('[data-prr-count]');
  if (tr && cnt) tr.addEventListener('scroll', function () { var n = tr.children.length, k = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)) + 1; cnt.textContent = k + ' / ' + n; }, { passive: true });
  document.querySelectorAll('[data-prr-sizeguide]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var d = document.getElementById('prr-fit');
      if (d) { d.open = true; window.scrollTo({ top: d.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' }); }
    });
  });
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the PRR brand cart drawer ===== */
(function () {
  if (window.__prr_atc) return; window.__prr_atc = 1;
  function open() { if (window.PRR && window.PRR.openCart) return window.PRR.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
